import React from 'react'
import { AppHeader } from '~/common/AppHeader'
import { Footer } from '~/common/Footer'
import '@css/pages/page/AddPage.scss'
import CommunitySettingsEdit from '~/pages/community/CommunitySettingsEdit'
import { useAuth } from '~/auth/Auth'
import { useWindowSize } from '~/common/hooks/useWindowSize'
import { PromptProvider } from '~/contexts/PromptContext'
import { useNavigate } from 'react-router'
import { useCommunity } from '~/contexts/CommunityContext'
import { useQuery } from '@apollo/client'
import { GetCommunitySettingsDocument } from '~/api/generated/graphql'

interface Props {
  creatingFreeSite: boolean
}

const FreeSiteSettings = ({ creatingFreeSite }: Props) => {
  const { isVeevan, profileVisible, loading: authLoading } = useAuth()
  const { isCondensed } = useWindowSize()
  const navigate = useNavigate()

  const { communityId, isFreeSite, loading } = useCommunity()
  const { loading: loadingCommunity, data } = useQuery(GetCommunitySettingsDocument, {
    variables: { id: communityId ?? '' },
    skip: !communityId || creatingFreeSite,
  })

  if ((!loading && !isFreeSite && !creatingFreeSite) || (!authLoading && !isVeevan)) {
    void navigate('../home}')
  }

  if (!creatingFreeSite && (loadingCommunity || authLoading || !data?.community?.communityId)) return <>Loading...</>

  const community =
    data?.community && !creatingFreeSite
      ? {
          communityId: data.community.communityId,
          name: data.community.name,
          description: data.community.description ?? null,
          photo: data.community.photo ?? null,
          aliases: (data.community.aliases as string[]) ?? [],
          type: data.community.type,
          company: {
            companyId: data.community.company?.companyId ?? '',
            name: data.community.company?.name ?? '',
            domains: data.community.company?.domains as unknown as string[],
          },
        }
      : undefined

  const condensedClass = isCondensed ? ' condensed' : ''

  if (authLoading) return null

  if (!isVeevan && !authLoading) {
    void navigate('/')
    return <></>
  }

  return (
    <>
      <AppHeader />
      <div className={`${creatingFreeSite ? 'add-page-wrapper' : ''}` + condensedClass}>
        <PromptProvider>
          <CommunitySettingsEdit
            community={community}
            isVeevan={isVeevan}
            isFreeSite={true}
            creatingFreeSite={creatingFreeSite}
            profileVisible={profileVisible}
          />
        </PromptProvider>
      </div>
      {creatingFreeSite && <Footer />}
    </>
  )
}

export default FreeSiteSettings
